import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import CoursesPic from "../../../images/BasicIK.png";
const CoursesPicContBIK = () => {
  return (
    <div className="QL__PG__PGAboutUsSec">
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <div className="QL__Sec__PGAboutUsmsg">
              <h1 className="HeadingAll">Basic Islamic Knowledge</h1>
              <p className="pt-3">
                LearnQuranQuick comprises the majority of skilled and
                intellectual tutors that are determined to help people of all
                ages to have a decent know-how about Islam and its fundamentals.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src={CoursesPic} alt="image" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default CoursesPicContBIK;
